import { getDateTimeParts } from './get-date-time-parts.mjs';
import { isSameYear } from './is-same-year.mjs';

function isSameMonth(date1, date2, timeZone) {
  const {
    month: month1
  } = getDateTimeParts(date1, timeZone);
  const {
    month: month2
  } = getDateTimeParts(date2, timeZone);
  return isSameYear(date1, date2, timeZone) && month1() === month2();
}

export { isSameMonth };
